import { render, staticRenderFns } from "./ConfirmarFondeador.vue?vue&type=template&id=6e3ff1c8"
import script from "./ConfirmarFondeador.vue?vue&type=script&lang=js"
export * from "./ConfirmarFondeador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports